import Nullstack from 'nullstack';
export default function IconShieldHalfFilled({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-shield-half-filled",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M12 3a12 12 0 0 0 8.5 3a12 12 0 0 1 -8.5 15a12 12 0 0 1 -8.5 -15a12 12 0 0 0 8.5 -3"
  }), "   ", Nullstack.element("path", {
    d: "M12 3v18"
  }), "   ", Nullstack.element("path", {
    d: "M12 11h8.9"
  }), "   ", Nullstack.element("path", {
    d: "M12 8h8.9"
  }), "   ", Nullstack.element("path", {
    d: "M12 5h3.1"
  }), "   ", Nullstack.element("path", {
    d: "M12 17h6.2"
  }), "   ", Nullstack.element("path", {
    d: "M12 14h8"
  }), " ");
}